/* unplugin-vue-components disabled */import { render } from "./LightButton.vue?vue&type=template&id=26d4586e&scoped=true&ts=true"
import script from "./LightButton.vue?vue&type=script&lang=ts"
export * from "./LightButton.vue?vue&type=script&lang=ts"

import "./LightButton.vue?vue&type=style&index=0&id=26d4586e&scoped=true&lang=css"
import "./LightButton.vue?vue&type=style&index=1&id=26d4586e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d4586e"]])

export default __exports__